import InvoiceListDesktop from './InvoiceListDesktop'

export default InvoiceListDesktop
